import React from 'react';
import PropTypes from 'prop-types';
import styles from './CustomBadgeComponent.module.css';
import { ADDED, REMOVED } from '../../../constants/constant';
const CustomBadgeComponent = (props) => {
	const cellValue = parseInt(props.value);
	const tagRenderer = (value) => {
		switch (value) {
			case 1:
				return <div className={styles.added}>{ADDED}</div>;
			case -1:
				return <div className={styles.removed}>{REMOVED}</div>;
			// You can add many more here ...
			default:
				return <div className={styles.added}>{ADDED}</div>;
		}
	};

	return <div className={styles.horizontalChips}>{tagRenderer(cellValue)}</div>;
};

CustomBadgeComponent.propTypes = {
	value: PropTypes.any,
};

export default CustomBadgeComponent;
